module.exports = __webpack_public_path__ + "img/icon-bell-active.35a750ea.svg";